import { makeStyle } from "../../utils";

const styles = {};


styles['container'] = makeStyle({ display: 'flex', flexDirection: 'column', height: '100%' });


styles['header'] = makeStyle({ position: 'sticky', top: 0, borderBottom: '1px solid #ddd' });


styles['body'] = makeStyle({ flex: 1, overflow: 'hidden', display: 'flex', position: 'relative' }, {});


export default styles;